import React, { useState } from "react";
import { Table, Form, FormControl, Button } from "react-bootstrap";
import TicketGrid from "./TicketGrid";
import { TicketApi } from "../../../redux/api/TicketApi";
import { ITicket } from "../../../types/Ticket/ITicket";
import { PartialSpinny } from "../../Nav/Spinny";

interface ITicketSearchProps {
    selectedId: number;
    onTicketSelected(ticketId: number): void;
}

const TicketSearch: React.FC<ITicketSearchProps> = (props) => {
    const [tickets, setTickets] = useState<ITicket[]>();
    const [searchOpenTickets, { isLoading: searching }] = TicketApi.useSearchTicketsMutation();
    const [searchTerm, setSearchTerm] = useState<string>("");

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    const handleSearch = () => {
        // Perform search logic here, e.g., call an API to fetch tickets based on the search term
        searchOpenTickets({ Search_Phrase: searchTerm }).then((tickets) => {
            if ('data' in tickets)
                setTickets(tickets['data'] as ITicket[])
        });
    }

    return (
        <div className="ticket-search">
            {searching && <PartialSpinny />}
            <Form className="d-flex mb-3" onSubmit={(e) => { e.preventDefault(); handleSearch() }}>
                <FormControl
                    required
                    type="search"
                    placeholder="Search phrase"
                    className="me-2"
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
                <Button variant="primary" type="submit">Search</Button>
            </Form>
            <TicketGrid data={tickets} showFilters={false} selectable={true} selectedTicketId={props.selectedId} onTicketSelected={props.onTicketSelected} />
        </div>
    );
};

export default TicketSearch;